<form [formGroup]="form" class="mat-typography">
    <table>
        <tr>
            <th>
                Field
            </th>

            <th>
                Current Value
            </th>

            <th>
                Desired Value
            </th>

            <th>
                Status
            </th>
        </tr>

        <tr>
            <td>
                State
            </td>

            <td>
                {{data?.state}}
            </td>

            <td>

                <mat-form-field appearance="fill">
                    <mat-label>State</mat-label>
                    <mat-select formControlName="state">
                        <mat-option [value]="'enabled'">Enabled</mat-option>
                        <mat-option [value]="'disabled'">Disabled</mat-option>
                    </mat-select>
                </mat-form-field>
            </td>

            <td>
                <sway-baseline-status [hasError]="errorsString.includes('state')"></sway-baseline-status>
            </td>
        </tr>

        <ng-container *ngIf="form.get('state')?.value === 'enabled'">
            <tr>
                <td>
                    Office Phone Allowed
                </td>

                <td>
                    {{data?.isOfficePhoneAllowed ? 'Allowed' : 'Not Allowed'}}
                </td>

                <td>
                    <mat-slide-toggle formControlName="isOfficePhoneAllowed">
                        {{ form.get('isOfficePhoneAllowed')?.value ? 'Allowed' : 'Not Allowed' }}
                    </mat-slide-toggle>
                </td>

                <td>
                    <sway-baseline-status [hasError]="errorsString.includes('isOfficePhoneAllowed')"></sway-baseline-status>
                </td>
            </tr>
        </ng-container>
    </table>

    <div class="mt-4" *ngIf="form.get('state')?.value === 'enabled'">
        <app-authentication-method-policy-targets
            [readOnly]="readOnly"
            [showIsUsableForSignIn]="false"
            [groups]="groups$ | async" [tenantId]="tenant_id" [form]="form"
            [policy]="data" [item]="baselineTemplateItem"
            [errorsString]="errorsString"></app-authentication-method-policy-targets>
    </div>
</form>
